import React from 'react';
import { Menu } from '@headlessui/react';
import { MoreHorizontal, Edit, Trash2 } from 'lucide-react';

export const BasketMenu = ({ onEdit, onDelete }) => {
  return (
    <Menu as="div" className="relative inline-block text-left">
      {({ open }) => (
        <>
          <Menu.Button className="menu-button text-neutral-900 hover:text-cranberry-700 transition-colors duration-200">
            <MoreHorizontal size={18} />
          </Menu.Button>
          
          {open && (
            <Menu.Items static className="absolute right-0 mt-2 w-48 origin-top-right rounded-xl bg-neutral-50 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50 border-2 border-neutral-900">
              <div className="px-1 py-1">
                <Menu.Item>
                  {({ active }) => (
                    <button
                      className={`${
                        active ? 'bg-neutral-200 text-neutral-900' : 'text-neutral-900'
                      } group flex w-full items-center rounded-lg px-2 py-2 text-sm font-medium`}
                      onClick={onEdit}
                    >
                      <Edit className="mr-2 h-5 w-5" aria-hidden="true" />
                      Edit
                    </button>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      className={`${
                        active ? 'bg-red-600 text-white' : 'text-neutral-900'
                      } group flex w-full items-center rounded-lg px-2 py-2 text-sm font-medium`}
                      onClick={onDelete}
                    >
                      <Trash2 className="mr-2 h-5 w-5" aria-hidden="true" />
                      Delete
                    </button>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          )}
        </>
      )}
    </Menu>
  );
};
